module.exports = __webpack_public_path__ + "static/image2-3265547ba227caf1b53f95f340654183.jpg";